import React from "react";
import {Scrollbars} from "react-custom-scrollbars";

const CustomScrollbars = (props) => (
  <Scrollbars
    {...props}
    autoHide
    renderTrackHorizontal={(props) => (
      <div {...props} style={{ display: "none" }} className="track-horizontal" />
    )}
    renderThumbHorizontal={(props) => (
      <div {...props} style={{ display: "none" }} className="thumb-horizontal" />
    )}
    renderThumbVertical={(props) => (
      <div {...props} className="thumb-vertical" />
    )}
    renderView={(viewProps) => {
      const { style, ...rest } = viewProps;
      // Scrollbar native disembunyikan lewat CSS (.gx-custom-scrollbars-view),
      // bukan margin negatif: margin -17px tidak cukup saat #root di-zoom 0.8,
      // sehingga scrollbar Windows tetap kelihatan.
      return (
        <div
          {...rest}
          style={{
            ...style,
            overflowX: "hidden",
            marginRight: 0,
            marginBottom: 0,
          }}
          className="gx-custom-scrollbars-view"
        />
      );
    }}
  />
);

export default CustomScrollbars;
